import $ from 'jquery'
import ScrollReveal from 'scrollreveal'

window.sr = ScrollReveal({ reset: true });

export default {

  enable () {
    sr.reveal('.block-menu-mosaique .columns', { mobile: false, duration: 200 },50);
    sr.reveal('.block-projets-en-avant .columns', { mobile: false, duration: 200 },50);
    sr.reveal('.block-latest-news .columns', { mobile: false, duration: 200 },50);
  }
}



// WEBPACK FOOTER //
// ./src/js/elements/scroll-reveal.js